<template>
  <section class="card mb-8">
    <h2 class="text-xl font-bold mb-4 text-primary-600">按分类筛选</h2>
    <div class="flex flex-wrap gap-2">
      <span 
        class="tag cursor-pointer transition-all duration-200" 
        :class="selectedCategory === null ? 'tag-primary' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
        @click="selectCategory(null)"
      >
        全部
      </span>
      <span 
        v-for="category in categories" 
        :key="category" 
        class="tag cursor-pointer transition-all duration-200"
        :class="selectedCategory === category ? getTagClass(category) : 'bg-gray-100 text-gray-600 hover:bg-gray-200'"
        @click="selectCategory(category)"
      >
        {{ category }}
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoryFilter',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    selectedCategory: {
      type: String,
      default: null
    }
  },
  methods: {
    selectCategory(category) {
      this.$emit('category-selected', category);
    },
    getTagClass(category) {
      // 根据分类名称返回不同的样式类
      const categoryMap = {
        '自然科学': 'tag-primary',
        '历史': 'tag-secondary',
        '生活': 'tag-accent',
        '天文': 'tag-fun',
        '动物': 'tag-primary',
        '植物': 'tag-accent',
        '技术': 'tag-secondary',
        '艺术': 'tag-fun',
        '数学': 'tag-primary',
        '语言': 'tag-secondary'
      };
      
      return categoryMap[category] || 'tag-primary';
    }
  }
}
</script>

<style scoped>
/* 样式已经在App.vue全局样式中定义 */
</style> 